


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Arrow from '@/components/icons/Arrow.vue';
import Info from '@/components/icons/Info.vue';

@Component({ components: { Surface, Picture, Typography, Arrow, Info } })
export default class TableCell extends Vue {
  @Prop(String) readonly sortKey?: string;
  @Prop({ default: false }) readonly sortable?: boolean;
  @Prop() readonly sortField?: any;
  @Prop() readonly sortOrder?: any;
  @Prop({ default: '12px 32px' }) readonly padding?: string;
  @Prop({ default: 'left' }) readonly textAlign?: 'left' | 'center' | 'right';
  @Prop() readonly tippy?: string;

  sort() {
    if (this.sortable) {
      this.$emit('sort', this.sortKey);
    }
  }
}
